module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-fill",
    attrs: {
      "to": "/comboform"
    }
  }, [_vm._v("Nuevo combo")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.combos), function(combo) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(combo.nombre))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [_c('li', [_c('router-link', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "to": ("/comboform/edit/" + (combo._id)),
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-edit"
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.eliminarCombo(combo._id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-remove"
    })])], 1)])])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("Acciones")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-076366d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Combos/ListaCombos.vue
// module id = 1104
// module chunks = 5